import React from "react"
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"

class AmenityPresenterGeneral extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    })
    return (
      <div className={tabClasses} id="general">
        <div className="row">
          <div className="col-md-7">
            <p><strong>{`${I18n.t('code')}: `}</strong>{this.props.amenity.value}</p>
            <p><strong>{`${I18n.t('name')}: `}</strong>{this.props.amenity.name}</p>
          </div>
        </div>
      </div>
    )
  }

}

export default AmenityPresenterGeneral